import React, { memo, useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Popup } from '@shared/ui';
import { MeasurementsInterface } from '@widgets/MeasurementsInterface';

import { MeasuremntsContext } from './Context/MeasuremntsContext';
import cls from './Measurements.module.css';
import { MeasurementsListWrapper } from './MeasurementsListWrapper/MeasurementsListWrapper';
import { MeasurementsModal } from './MeasurementsModal/MeasurementsModal';
import { ImagePrevModal } from './UI/ImagePrevModal/ImagePrevModal';
import { useMeasurements } from './useMeasurements';
import { Loader } from '../../components/UI/NewLoader/Loader/Loader';
import { useInfiniteScrollNew } from '../../shared/hooks/useInfinityScrollNew';
import { loadMoreMeasurements } from '../../store/slices/measurementsSlice/action';
import { measurementsSelector } from '../../store/slices/measurementsSlice/measurementsSlice';
import { Loader as MoreLoader } from '../Files/UI/FileCard/Loader/Loader';

export const Measurements = memo(() => {
    const {
        measurementsLoading,
        onAddMeasurementsList,
        isClosing,
        onHideModal,
        measurementsContextValue,
        popupProps,
    } = useMeasurements();
    const { t } = useTranslation();
    const { isOpenPrevImage, isShowModal } = useSelector((state) => state.measurementsReducer);

    const { needFetchMore } = useSelector((state) => state.measurementsReducer);
    const isLoadingMore = useSelector((state) => state.measurementsReducer.measurementsLoadingMore);
    const dispatch = useDispatch();

    const onLoadNextPart = useCallback(() => {
        dispatch(loadMoreMeasurements());
    }, [needFetchMore]);

    const lastElementRef = useInfiniteScrollNew(onLoadNextPart);
    const ids = useSelector(measurementsSelector.selectIds);
    return (
        <MeasuremntsContext.Provider value={measurementsContextValue}>
            {measurementsLoading && <Loader />}
            <div>
                {popupProps.isOpen && (
                    <Popup
                        isOpen={popupProps.isOpen}
                        onHidePopup={popupProps.onCancel}
                        type={popupProps.danger ? 'delete' : 'alert'}
                        contentText={typeof popupProps.text === 'string' ? popupProps.text : ' '}
                        btnActionCb={popupProps.onSubmit}
                        deleteButtonText={popupProps.danger}
                        cancelButtonText={popupProps.cancel}
                        alertBtnText={popupProps.cancel || popupProps.success}
                    >
                        {typeof popupProps.text !== 'string' ? popupProps.text : null}
                    </Popup>
                )}
                {/*
                {popupProps.isOpen && <Popup {...popupProps} />}
                */}
                {isShowModal && (
                    <MeasurementsModal isClosing={isClosing} onHideModal={onHideModal} />
                )}
                <MeasurementsInterface
                    isLoadingMeasurementsData={measurementsLoading}
                    onAddMeasurementsList={onAddMeasurementsList}
                />

                <MeasurementsListWrapper />
                {!!isOpenPrevImage && <ImagePrevModal />}
            </div>
            {needFetchMore && !!ids.length && <div ref={lastElementRef} />}
            {isLoadingMore && (
                <div className={cls.moreLoader}>
                    <MoreLoader />
                </div>
            )}
        </MeasuremntsContext.Provider>
    );
});
